import { ApiUrl } from "../../components/Common/ApiUrl";
import { Constants } from "../../components/Common/Constants";
import httpServiceInstance from "../../helper/HttpService";

export const bodyGroupAdd = async (data) => {
  const response = await httpServiceInstance.post(ApiUrl.BODY_GROUP, data);
  console.log("bodyGroupAdd response:", response);
  console.log("bodyGroupAdd status:", response?.status);
  console.log("bodyGroupAdd statusCode:", response?.statusCode);
  return response;
};

export const bodyGroupEdit = async (data) => {
  const response = await httpServiceInstance.patch(ApiUrl.BODY_GROUP, data);
  console.log("bodyGroupEdit response:", response);
  console.log("bodyGroupEdit status:", response?.status);
  console.log("bodyGroupEdit statusCode:", response?.statusCode);
  console.log("bodyGroupEdit data:", response?.data);
  return response;
};

export const bodyGroupRemove = async (id) => {
  const response = await httpServiceInstance.delete(
    ApiUrl.BODY_GROUP + `/${id}`
  );
  console.log("bodyGroupRemove response:", response);
  console.log("bodyGroupRemove status:", response?.status);
  console.log("bodyGroupRemove statusCode:", response?.statusCode);
  return response;
};

export const bodyGroup = async (data) => {
  const response = await httpServiceInstance.get(
    `${ApiUrl.BODY_GROUP}${
      data?.skipPagination
        ? `?${Constants.paginationFalse}`
        : `?skip=${data?.skip || 0}&limit=${
            data?.limit || Constants.limitCount
          }`
    }${data && data?.search ? `&search=${data?.search}` : ""}${
      data?.status ? `&status=${data?.status}` : ""
    }`
  );
  console.log("bodyGroup response:", response);
  return response;
};
